import "@suite/documents/theme/tokens.css";
import "@suite/documents/theme/workspace.css";
import "@suite/panels/theme/tokens.css";
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ChakraProvider } from '@chakra-ui/react';
import { BrowserRouter } from 'react-router-dom';
import App from './app/App';
import { HubGateRoot } from './gate/HubGateRoot';
import { TourProvider } from '@suite/tour';
import { theme } from './themes';
import './styles/global.css';
// i18n must initialize before the app renders (resources are bundled, init is synchronous).
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
    <HubGateRoot appId="yap" appName="Yap">
        <React.StrictMode>
            {/* No ColorModeScript: appearance is owned by the suite runtime
                (window.SuiteTheme); ThemeSync bridges it onto Chakra. */}
            <ChakraProvider theme={theme}>
                {/* First-run tour provider (docs/product/onboarding-tour): inert
                    until the engine's gate starts it; flag lives in localStorage. */}
                <TourProvider>
                    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
                        <App />
                    </BrowserRouter>
                </TourProvider>
            </ChakraProvider>
        </React.StrictMode>
    </HubGateRoot>
);

// Disable default browser context menu globally
window.addEventListener('contextmenu', (e) => {
    e.preventDefault();
}, { passive: false });
